import { render, staticRenderFns } from "./MatterDetail.vue?vue&type=template&id=39ce7816&scoped=true&"
import script from "./MatterDetail.vue?vue&type=script&lang=js&"
export * from "./MatterDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatterDetail.vue?vue&type=style&index=0&id=39ce7816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce7816",
  null
  
)

export default component.exports